import PageLoadAnimation from "../page-load-animation"
import StripeDisplay from "../stripe"
import MbWayContact from "../mbway-contact"

class AsyncPaymentChecks {
    constructor(el) {
        this._init(el)
    }

    _init(el) {
        // this.el = document.querySelector('[data-async-payment]')
        if(el) {
            this.el = el
        } else {
            this.el = document.querySelector('[data-payment-method]')
        }
        if(!this.el) { 
            return
        }

        this.checkIds = {
            'STRIPE_CREDIT_CART_ID': 100,
            'IFTHENPAY_MBWAY_ID': 105
        }

        this.loading = new PageLoadAnimation(false)

        this.elActions = this.el.querySelectorAll('[data-payment-method-element]')
        this.elActions.forEach(el => {
            let id = this.getElActionId(el)
            if(id == this.checkIds['STRIPE_CREDIT_CART_ID']) {
                el.payment = new StripeDisplay(el)
            }
            else if(id == this.checkIds['IFTHENPAY_MBWAY_ID']) {
                el.payment = new MbWayContact(el)
            }
        })

        //#region update payment form
            this.elForm = document.querySelector('[data-payment-method]')
            if(!this.elForm) {
                return;
            }

            this.elsAction = document.querySelectorAll('[data-payment-method-action]')
            if (this.elsAction.length == 0) {
                return
            }
            this.elsAction.forEach(el => {
                el.addEventListener('click', (e) => {
                    e.preventDefault()
                    this.runChecks()
                        .then(() => {
                            this.elForm.submit()
                            this.setLoadingAnimation(true)
                        })
                        .catch((error) => {
                            console.log("Invalid Payment Method")
                            // console.log(error)
                        })
                })
            })
            this.elForm.addEventListener('submit', (e) => {
                e.preventDefault()
                this.runChecks()
                    .then(() => {
                        this.elForm.submit()
                        this.setLoadingAnimation(true)
                    })
                    .catch((error) => {
                        console.log("Invalid Payment Method")
                        // console.log(error)
                    })
            })
        //#endregion
    }

    runChecks() {
        return new Promise((resolve, reject) => {
            this.setLoadingAnimation(true)
            let id = null
            let promises = []
            this.elActions.forEach(el => {
                if(el.checked) {
                    id = this.getElActionId(el)
                    if(el.paymentID == id) {
                        promises.push(el.method.getSource())
                    } else {
                        promises.push(Promise.resolve('nothing to check'))
                    }
                }
            })
            Promise.all(promises)
                .then(result => {
                    // console.log(result)
                    resolve(result)
                })
                .catch(error => {
                    // console.log(error)
                    reject(error)
                })
        })
        .finally(() => {
            this.setLoadingAnimation(false)
        })
    }

    getElActionId(el) {
        return el.getAttribute('id').split('-').pop()
    }


    setLoadingAnimation(on) {
        if(this.loading && this.loading.promiseInit()) {
            this.loading.toggleLoading(on)
        }
        else {
            this.loading = null;
        }
    }
}

export default AsyncPaymentChecks